module.exports = "<div class=\"r partnership-grid {{vm.viewMode}}\"> <div class=c ng-repeat=\"partnership in vm.partnerships\"> <partnership-tile partnership=partnership></partnership-tile> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/seller/components/partnership-grid.html
// module id = 664
// module chunks = 0